import { ReactNode } from "react";
import { ServiceTitanExternalLink } from "./service-titan-external-link";

interface ServiceTitanJobLinkProps {
  jobId: number;
  children?: ReactNode;
}

export const ServiceTitanJobLink = ({
  jobId,
  children,
}: ServiceTitanJobLinkProps) => {
  const url = `/#/Job/Index/${jobId}`;

  return (
    <ServiceTitanExternalLink url={url}>
      {children ?? `Job ${jobId}`}
    </ServiceTitanExternalLink>
  );
};
